<template>
    <div class="w-full flex flex-col">
        <h1
            style="word-break: break-word !important"
            class="font-display-4 w-full md:text-5xl line-clamp-2 md:leading-10"
            v-text="document.filename"
        ></h1>

        <div class="flex flex-wrap items-center mt-2">
            <div class="flex items-center text-slate-600 mr-4 mt-1">
                <i class="icon icon-documents"></i>
                <span class="ml-2">{{ document.file_type_label }}</span>
            </div>

            <div class="flex items-center mt-1 mr-2">
                <component
                    :is="!document.user_data.anonymous ? 'a' : 'div'"
                    class="flex items-center"
                    :href="
                        document.user_data.anonymous || userIsDeleted
                            ? null
                            : route('profile.show', {
                                  id: document.user_data.id,
                                  slug: document.user_data.slug,
                              })
                    "
                >
                    <img
                        v-if="!document.user_data.anonymous"
                        class="inline-block rounded-full w-8"
                        :src="document.user_data.profilePictureURL"
                        :alt="document.user_data.name"
                    />
                    <div
                        v-else
                        class="bg-slate-300 inline-flex items-center justify-center rounded-full w-8 md:w-9 h-8 md:h-9"
                    >
                        <span class="icon icon-incognito text-slate-400"></span>
                    </div>
                    <div class="ml-1 leading-tight">
                        <span class="font-medium">
                            {{ document.user_data.name }}
                        </span>
                        <span
                            v-if="!document.user_data.anonymous && !userIsDeleted"
                            class="p-1 text-xs bg-purple-100 text-purple-700 border-none rounded-md ml-1"
                        >
                            {{ document.user_data.karmaPoints }}
                        </span>
                    </div>
                </component>
            </div>
        </div>
        <div class="text-slate-400 text-xs mt-1 mb-6">
            {{ document.time }}
        </div>

        <h4 class="mb-3">{{ $t('show.description') }}</h4>
        <p class="text-slate-600 leading-6 mb-4">
            {{ document.description }}
        </p>
        <div v-if="document.language?.name">
            <h4 class="mb-3">{{ $t('edit.languageLabel') }}</h4>
            <p class="text-slate-600 leading-6">
                {{ document.language?.name }}
            </p>
        </div>
    </div>
</template>

<script>
import route from '@router/route';
import { mapGetters } from 'vuex';
import UserAvatar from '@components/UserAvatar';

export default {
    name: 'DocumentShowDetails',
    i18nOptions: {
        namespaces: ['document'],
    },
    components: {
        UserAvatar,
    },
    computed: {
        ...mapGetters({
            document: 'document/currentDocument',
        }),
        userIsDeleted() {
            return !this.document.user_data.id;
        },
    },
    methods: {
        route,
    },
};
</script>
